export const commonUtils = {
  tomorrow: '昨天 {time}',
  login: '登录中',
  openIdError: 'openID 未绑定',
  expireProjectWarning: '存在已过期的项目，需在电脑端续费，即可查看项目数据'
}
